import React from 'react'
import styles from './StoreProperty.module.scss'
import { Typography, Link } from '@mui/material'

interface IStoreProps {
  property: string
  propertyValue: string
  variant?: 'smallText' | 'body'
  href?: string
}

export const StoreProperty: React.FC<IStoreProps> = (props) => {
  const { property, propertyValue, href, variant = 'body' } = props
  return (
    <div className={styles.propertyContainer}>
      <Typography variant={`${variant}Bold`} className={styles.property}>
        {property}
      </Typography>
      <Typography variant={variant}>
        {href ? (
          <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            underline="none"
          >
            {propertyValue}
          </Link>
        ) : (
          propertyValue
        )}
      </Typography>
    </div>
  )
}
